import { render } from "./CommLogin_side.vue?vue&type=template&id=a3bbeb26"
import script from "./CommLogin_side.vue?vue&type=script&lang=js"
export * from "./CommLogin_side.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__